export const request = <T>(url: RequestInfo, options?: RequestInit): Promise<T> =>
  fetch(url, options)
    .then(handleErrors)
    .then((response) => getBody<T>(response));

request.get = <T>(url: RequestInfo, options?: Omit<RequestInit, 'method'>) =>
  request<T>(url, { ...options, method: 'GET' });

request.post = <T>(url: RequestInfo, options: Omit<RequestInit, 'method'>) =>
  request<T>(url, { ...options, method: 'POST' });

export class RequestError extends Error {
  status: string;

  constructor(message: string, status: string) {
    super(message);
    this.status = status;
  }
}

function handleErrors(response: Response): Response {
  if (!response.ok) {
    throw new RequestError(response.statusText, response.status.toString());
  }
  return response;
}

function getBody<T>(response: Response): Promise<T> {
  return response.json() as Promise<T>;
}
